export default __webpack_public_path__ + "static/media/eye-closed.ac7cd229.svg";